import { motion } from "framer-motion";
import { Atom, Layers, FileCode2, Feather, Hexagon, Braces, Database, Cloud, Wind } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const TECHS = [
  { name: "React", icon: Atom },
  { name: "Next.js", icon: Layers },
  { name: "TypeScript", icon: FileCode2 },
  { name: "Flutter", icon: Feather },
  { name: "Node.js", icon: Hexagon },
  { name: "Python", icon: Braces },
  { name: "PostgreSQL", icon: Database },
  { name: "AWS", icon: Cloud },
  { name: "Tailwind CSS", icon: Wind },
];

export default function TechStack() {
  const { t } = useLang();
  return (
    <section id="teknolojiler" className="relative py-24 lg:py-32 bg-[#191C22]" data-testid="techstack-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6"
        >
          <div>
            <span className="glow-badge rounded-full px-4 py-1.5 text-xs font-medium tracking-widest uppercase">
              {t.tech.badge}
            </span>
            <h2 className="mt-6 font-heading font-black tracking-tighter text-white text-3xl md:text-5xl">
              {t.tech.title_pre}
              <span className="text-[#5B7FFF]">{t.tech.title_accent}</span>
            </h2>
          </div>
          <p className="text-slate-400 text-sm md:text-base leading-relaxed max-w-md">{t.tech.desc}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-4">
          {TECHS.map((tech, i) => (
            <motion.div
              key={tech.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              whileHover={{ y: -6 }}
              className="glass-card rounded-xl aspect-square flex flex-col items-center justify-center gap-3 hover:border-[#5B7FFF]/40 transition-colors duration-300 cursor-default"
              data-testid={`tech-tile-${tech.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
            >
              <tech.icon size={26} className="text-[#5B7FFF]" />
              <span className="text-xs text-slate-300 font-medium text-center px-2">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
